import { Types } from 'cafe-utility';
import { http } from "../../utils/http.js";
import { BZZ } from "../../utils/tokens.js";
import { asNumberString } from "../../utils/type.js";
const settlementsEndpoint = 'settlements';
/**
 * Get amount of sent and received from settlements with a peer
 *
 * @param requestOptions Options for making requests
 * @param peer  Swarm address of peer
 */
export async function getSettlements(requestOptions, peer) {
  const response = await http(requestOptions, {
    url: `${settlementsEndpoint}/${peer}`,
    responseType: 'json'
  });
  const body = Types.asObject(response.data, {
    name: 'response.data'
  });
  return {
    peer: Types.asString(body.peer, {
      name: 'peer'
    }),
    sent: BZZ.fromPLUR(asNumberString(body.sent, {
      name: 'sent'
    })),
    received: BZZ.fromPLUR(asNumberString(body.received, {
      name: 'received'
    }))
  };
}
/**
 * Get settlements with all known peers and total amount sent or received
 *
 * @param requestOptions Options for making requests
 */
export async function getAllSettlements(requestOptions) {
  const response = await http(requestOptions, {
    url: settlementsEndpoint,
    responseType: 'json'
  });
  const body = Types.asObject(response.data, {
    name: 'response.data'
  });
  const totalSent = BZZ.fromPLUR(asNumberString(body.totalSent, {
    name: 'totalSent'
  }));
  const totalReceived = BZZ.fromPLUR(asNumberString(body.totalReceived, {
    name: 'totalReceived'
  }));
  const settlements = Types.asArray(body.settlements, {
    name: 'settlements'
  }).map(x => Types.asObject(x, {
    name: 'settlement'
  }));
  return {
    totalSent,
    totalReceived,
    settlements: settlements.map(x => ({
      peer: Types.asString(x.peer, {
        name: 'peer'
      }),
      sent: BZZ.fromPLUR(asNumberString(x.sent, {
        name: 'sent'
      })),
      received: BZZ.fromPLUR(asNumberString(x.received, {
        name: 'received'
      }))
    }))
  };
}